<div>
	<nz-select
		[nzMaxTagCount]="3"
		[nzMaxTagPlaceholder]="tagPlaceHolder"
		nzMode="multiple"
		nzPlaceHolder="Please select"
		[ngModel]="groups()"
		(ngModelChange)="onSelectionChange($event)"
	>
		@for (group of allGroups(); track group) {
			<nz-option [nzLabel]="group" [nzValue]="group"></nz-option>
		}
	</nz-select>

	<ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
</div>
